class SiteConfigUtils {
  constructor(siteConfigData) {
    this._siteConfigData = siteConfigData;
  }
  normalizeRouteForPageConfig(curRouteName) {
    if (curRouteName.charAt(0) == "/") curRouteName = curRouteName.substring(1);

    return curRouteName;
  }
  getPageConfig(curRouteName) {
    curRouteName = this.normalizeRouteForPageConfig(curRouteName);

    return this._siteConfigData.pages.find(
      (page) =>
        page.id == curRouteName ||
        page.id == curRouteName.substring(0, curRouteName.length - 1)
    );
  }
}

export default function (app, context) {
  app.provide("siteConfig", {
    siteConfigData: context.siteConfigData,
    siteConfigUtils: new SiteConfigUtils(context.siteConfigData),
  });
}